/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Public_Link_CopiedInputs */



/**
* | output |
* | --- |
* | "Public link copied to clipboard" |
*
* @param {Artifact_Public_Link_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_public_link_copied = /** @type {((inputs?: Artifact_Public_Link_CopiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Public_Link_CopiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffentlicher Link in die Zwischenablage kopiert")
	return /** @type {LocalizedString} */ ("Public link copied to clipboard")
});